export enum responseType {
    success = 1,
    error = 2
}

export enum IFileMode {
    download = 1,
    upload = 2
}

export interface IBulkImport {
    status: number,
    message: string,
    error: string
}